import { StoreExt } from '@utils/reactExt'
import { observable, action, runInAction } from 'mobx'
import { homeStore } from '@views/home/actor/store'

class HomeStoreG extends StoreExt {
    @observable simInfo: any = {}
    @observable subAreas: any[] = []
    @observable isInActive: boolean = false    // 是否正在激活中（接口pending状态）
    @observable activeSuccess: boolean = false  // 是否激活成功
    @observable currentArea: string     // 当前地区
    @observable currentCargoType: string  // 当前地区对应的货币
    @observable padControlFlag: any
    @observable vf_iframe: any
    @action
    vf_iframeSuccess = flag => {
        runInAction(() => {
            this.vf_iframe = flag
        })
    }
    @action
    setActiveSuccess = flag => {
        runInAction(() => {
            this.activeSuccess = flag
        })
    }
    @action
    setCurrentArea = areaId => {
        this.currentArea = areaId
    }

    @action
    setCurrentCargoType = cargoType => {
        this.currentCargoType = cargoType
    }

    @action
    getUserInfo = async () => {
        try {
            const res = await this.api.getUserInfo({})
            localStorage.toKey = res.toKey || ''
            localStorage.setItem('userInfo', JSON.stringify(res))
            return JSON.stringify(res) === '{}' ? '' : res
        } catch (e) {
        }
    }

    @action
    getOperatorId = async (simId) => {
        try {
            const res = await this.api.getOperatorId({ simId })
            return res
        } catch (e) {
        }
    }

    // 流量图表
    @action
    getCardFlowDetail = async (simId) => {
        try {
            const res = await this.api.getCardFlowDetail({ simId })
            runInAction(() => {
                this.simInfo = { ...this.simInfo, ...res }
            })
        } catch (e) {
        }
    }
    @action
    getSimInfo = async (simId) => {
        try {
            const res = await this.api.getCardUserInfo({ simId })
            this.getCardFlowDetail(simId)
            if (localStorage.getItem('chl') === 'tabletApp' && res.active === false) { // 平板项目默认自动激活
                // homeStoreG.activePackage(res.simId)
            }
            runInAction(() => {
                this.simInfo = res
            })
        } catch (e) {
        }
    }
    @action
    getPadControlFlag = async () => {
        try {
            const res = await this.api.getPadControlFlag({})
            runInAction(() => {
                this.padControlFlag = res
            })
        } catch (error) {
        }
    }
    @action
    getSubAreas = async (simId) => {
        try {
            let res = []
            const data = await this.api.querySubAreas({ simId })
            if (localStorage.getItem('chl') === 'tabletApp') {
                res = data.filter((item) => item.cargoType === '1')
            } else {
                res = data
            }
            localStorage.setItem('subAreas', JSON.stringify(res))
            this.setCurrentArea(res[0].parentAreaId)
            this.setCurrentCargoType(res[0].cargoType)
            runInAction(() => {
                this.subAreas = JSON.stringify(res) === '{}' ? [] : res
            })
        } catch (e) {
        }
    }

    @action
    activePackage = async simId => {
        this.showLoading()
        try {
            await this.api.active({ simId: simId })
            this.setActiveSuccess(true)
            // 如果没有当前套餐，就重新调simInfo和加油包接口
            if (!this.simInfo.startDate) {
                this.getSimInfo(simId)
                homeStore.getRefuelPackage({
                    cargoType: this.currentCargoType
                })
            }
        } catch (e) { } finally {
            this.hideLoading()
        }
    }

    @action
    activePackageVF = async simId => {
        this.showLoading()
        try {
            const res = await this.api.checkActiveStatusVF({ simId: simId })
            const { active = false } = res
            if (!active) {
                const resActive = await this.api.activeVF({ simId: simId, mock: '0' })
                const { lenovo_ID = '', imei = '', msisdn = '', vf_PAGE_URL = '', callback_URL = '' } = resActive;
                window.location.href = `${vf_PAGE_URL}?LENOVO_ID=${lenovo_ID}&IMEI=${imei}&MSISDN=${msisdn}&CALLBACK_URL=%22${callback_URL}%22`
                // this.vf_iframeSuccess(`${vf_PAGE_URL}?LENOVO_ID=${lenovo_ID}&IMEI=${imei}&MSISDN=${msisdn}&CALLBACK_URL=%22${callback_URL}%22`)
            }
        } catch (e) { } finally {
            this.hideLoading()
        }
    }
}

const homeStoreG = new HomeStoreG()
export { homeStoreG, HomeStoreG }
